import { Component, ChangeDetectionStrategy, ChangeDetectorRef, Input, Output, EventEmitter, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';

interface TimeItem {
  value: string;
  display: string;
}

@Component({
  selector: 'tidy-time-scroller',
  templateUrl: './tidy-time-scroller.component.html',
  styleUrls: ['./tidy-time-scroller.component.scss'],
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TidyTimeScrollerComponent implements OnInit, AfterViewInit {
  @Input() rangeStart: string | null = null;
  @Input() rangeEnd: string | null = null;
  @Output() rangeChanged = new EventEmitter<{ start: string; end: string | null }>();

  @ViewChild('track', { static: false }) trackEl: ElementRef;

  times: TimeItem[] = [];
  showLeftArrow = false;
  showRightArrow = true;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.times = [
      { value: '08:00', display: '8am' },
      { value: '09:30', display: '9:30am' },
      { value: '11:00', display: '11am' },
      { value: '12:30', display: '12:30pm' },
      { value: '14:00', display: '2pm' },
      { value: '15:30', display: '3:30pm' },
      { value: '17:00', display: '5pm' },
      { value: '18:30', display: '6:30pm' },
      { value: '20:00', display: '8pm' },
      { value: '21:00', display: '9pm' }
    ];
  }

  ngAfterViewInit() {
    this.updateArrows();
  }

  selectTime(item: TimeItem) {
    if (!this.rangeStart) {
      this.rangeStart = item.value;
      this.rangeEnd = null;
    } else if (!this.rangeEnd) {
      if (item.value === this.rangeStart) {
        this.rangeStart = null;
        this.rangeEnd = null;
      } else if (item.value < this.rangeStart) {
        this.rangeEnd = this.rangeStart;
        this.rangeStart = item.value;
      } else {
        this.rangeEnd = item.value;
      }
    } else {
      if (item.value >= this.rangeStart && item.value <= this.rangeEnd) {
        this.rangeStart = item.value;
        this.rangeEnd = null;
      } else if (item.value < this.rangeStart) {
        this.rangeStart = item.value;
      } else {
        this.rangeEnd = item.value;
      }
    }
    this.rangeChanged.emit({ start: this.rangeStart, end: this.rangeEnd });
    this.cdr.markForCheck();
  }

  isInRange(value: string): boolean {
    if (!this.rangeStart) {return false;}
    if (!this.rangeEnd) {return value === this.rangeStart;}
    return value >= this.rangeStart && value <= this.rangeEnd;
  }

  scrollRight = () => {
    const el = this.trackEl?.nativeElement;
    if (el) {el.scrollBy({ left: el.clientWidth, behavior: 'smooth' });}
  };

  scrollLeft = () => {
    const el = this.trackEl?.nativeElement;
    if (el) {el.scrollBy({ left: -el.clientWidth, behavior: 'smooth' });}
  };

  onScroll = () => {
    this.updateArrows();
  };

  private updateArrows() {
    const el = this.trackEl?.nativeElement;
    if (!el) {return;}
    this.showLeftArrow = el.scrollLeft > 10;
    this.showRightArrow = el.scrollLeft < el.scrollWidth - el.clientWidth - 10;
  }

  trackByValue(_index: number, item: TimeItem): string {
    return item.value;
  }
}
